type ValidValue<T> = Exclude<T, null | undefined | 0 | '' | false>;

/**
 * A type guard that checks if a value is a valid value.
 * @returns true if the value is not null, undefined, 0, '', or false.
 */
export const BooleanFilter = <T>(x: T): x is ValidValue<T> => Boolean(x);
